import { sortReplies } from '@btime/helpers'
import React from 'react'

import { useGroupedRepliesByCategory } from '../../../containers/dynamic/presentationList/categories/_data/groupByCategories'
import { useReplies, useServiceOrder } from '../resumeV2/_load/ServiceOrderLoader'
import { useResumeCounters } from '../resumeV2/general/_data/counters'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import OptionsForm from './options/OptionsForm'
import PdfDocument from './PdfDocument'
import PdfOptionsFormHandler from '../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Preview from '../../../components/pdf/Preview'
import { useChildrenServiceOrders } from '../resumeV2/_load/ChildrenServiceOrderLoader'

const PageContent = () => {
  const serviceOrder = useServiceOrder()
  const replies = useReplies()
  const categories = useGroupedRepliesByCategory(sortReplies(replies))
  const counters = useResumeCounters()

  const childrenServiceOrders = useChildrenServiceOrders()

  const props = {
    serviceOrder,
    categories,
    counters,
    childrenServiceOrders
  }

  return (
    <PdfOptionsFormHandler>
      <FlexGrid align="stretch">
        <FlexCol flex={3} invisibleOn="mdd">
          <Preview>
            <PdfDocument {...props} />
          </Preview>
        </FlexCol>

        <FlexCol flex={1}>
          <OptionsForm />
        </FlexCol>
      </FlexGrid>
    </PdfOptionsFormHandler>
  )
}

export default PageContent
